import * as React from 'react';
import { connect } from 'react-redux';
import { isAuthenticated } from '@/redux/modules/user';
import { Navigate, useLocation } from 'react-router-dom';

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

type Props = {
    component: any;
    isAuthenticated: boolean;
};

// React Router v6 compatible PrivateRoute
// This is a wrapper component that checks authentication
const PrivateRoute: React.FC<Props> = ({ component: Component, isAuthenticated }) => {
    const location = useLocation();

    if (!isAuthenticated) {
        return (
            <Navigate
                replace
                state={{ from: location }}
                to="/login"
            />
        );
    }

    return <Component />;
};

export default connect(mapStateToProps)(PrivateRoute);
